var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89836 2.00333C2.79005 1.97187 2.67526 1.97029 2.56613 1.99878C2.45701 2.02727 2.35763 2.08475 2.27852 2.16514C2.19942 2.24552 2.14354 2.34582 2.11681 2.45539C2.09008 2.56495 2.09349 2.67971 2.12669 2.7875L4.15336 9.375H11.25C11.4158 9.375 11.5748 9.44084 11.692 9.55805C11.8092 9.67527 11.875 9.83424 11.875 10C11.875 10.1658 11.8092 10.3247 11.692 10.4419C11.5748 10.5591 11.4158 10.625 11.25 10.625H4.15336L2.12669 17.2125C2.09369 17.3202 2.09042 17.4349 2.11724 17.5443C2.14406 17.6538 2.19996 17.7539 2.27904 17.8342C2.35811 17.9144 2.45741 17.9718 2.56643 18.0003C2.67545 18.0288 2.79014 18.0272 2.89836 17.9958C2.89836 17.9958 13.6091 13.8603 18.2692 10.5075C18.3497 10.4496 18.4153 10.3734 18.4606 10.2852C18.5058 10.1969 18.5294 10.0992 18.5294 10C18.5294 9.90083 18.5058 9.80308 18.4606 9.71483C18.4153 9.62659 18.3497 9.55038 18.2692 9.4925C13.6092 6.13941 2.89836 2.00333 2.89836 2.00333Z",
    fill: "#E4441C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/icon_send.446403eea9e4d6be9aafac2a8a90306f.svg";
export { ForwardRef as ReactComponent };